<template>
  <div
    class=""
    style="display: flex; flex-direction: column; flex: 1"
    :id="componentId"
  >
    <div style="display: flex; flex-direction: row; flex: 1">
      <div
        style="display: flex; flex-direction: column"
        v-for="star in palace.stars"
        :key="star.name"
        :style="{ 'font-size': fontSize + 'px' }"
      >
        <div :style="{ color: starClass(star.class) }">
          {{ star.name[0] }}
        </div>
        <div :style="{ color: starClass(star.class) }">
          {{ star.name[1] }}
        </div>
        <div v-if="star.fourMode[0]" class="four-mode">
          {{ star.fourMode[0] }}
        </div>
      </div>
    </div>
    <div
      style="display: flex; flex-direction: row; justify-content: space-between"
    >
      <div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: red;
            margin-bottom: -1px;
          "
          v-if="stampCount > 1"
        >
          <span
            style="border: 1px solid red; margin-bottom: 1px; line-height: 16px"
            v-if="palace.yearly.palaceId == 0"
          >
            <div>流</div>
            <div>年</div>
          </span>
          <span
            style="border: 1px solid red; margin-bottom: 1px; line-height: 16px"
            v-if="palace.decade.palaceId == 0"
          >
            <div>大</div>
            <div>运</div>
          </span>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: red;
          "
          v-else
        >
          <span
            style="border: 1px solid red"
            v-if="palace.yearly.palaceId == 0"
          >
            <div>流</div>
            <div>年</div>
          </span>
          <span
            style="border: 1px solid red"
            v-if="palace.decade.palaceId == 0"
          >
            <div>大</div>
            <div>运</div>
          </span>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; justify-content: flex-end"
      >
        <div>{{ palace.heavenlyName }}</div>
        <div>{{ palace.earthlyName }}</div>
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%, 0);
      "
    >
      <div style="font-size: 10px">{{ palace.ageGap }}</div>
      <div style="margin-bottom: 1px">
        <span style="color: white; background-color: red; padding: 1px">
          {{ palaceName }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    palace: { type: Object },
    palaceId: null,
  },
  data() {
    return {
      fontSize: 14,
    }
  },
  mounted: function () {
    const resize_ob = new ResizeObserver(
      function () {
        if (this.fontSize <= 8) return

        // let rect = entries[0].contentRect
        // console.log(rect)

        // current width & height
        // let width = rect.width
        let width = this.fontSize * this.palace.stars.length

        const wrapperWidth =
          document.getElementsByClassName('wrapper')[0].offsetWidth
        const cellWidth = wrapperWidth / 4 - 2
        if (width > cellWidth) {
          this.fontSize--
        }
      }.bind(this)
    )

    // start observing for resize
    resize_ob.observe(document.getElementById(this.componentId))
  },
  computed: {
    componentId: function () {
      return 'palace' + this.palaceId
    },
    thisWidth: function () {
      return document.getElementById(this.componentId).offsetWidth
    },
    palaceName: function () {
      if (this.palace.isBodyPalace === 1) {
        const PALACE_SHORT_NAME = {
          0: '命/身',
          1: '兄/身',
          2: '夫/身',
          3: '子/身',
          4: '财/身',
          5: '疾/身',
          6: '迁/身',
          7: '友/身',
          8: '事/身',
          9: '宅/身',
          10: '福/身',
          11: '父/身',
        }
        return PALACE_SHORT_NAME[this.palace.palaceId]
      }
      return this.palace.palaceName
    },
    stampCount: function () {
      let count = 0
      if (this.palace.yearly.palaceId == 0) {
        count++
      }
      if (this.palace.decade.palaceId == 0) {
        count++
      }
      return count
    },
  },
  methods: {
    starClass: function (classLevel) {
      const STAR_LEVEL_COLOR = {
        0: 'red',
        1: 'blueviolet',
        2: 'dodgerblue',
        3: 'black',
      }
      return STAR_LEVEL_COLOR[classLevel]
    },
    resetFontSize: function () {
      this.fontSize = 14
    },
  },
}
</script>

<style>
.stars {
  font-size: 14px;
}
.stars-wrapper {
  display: flex;
  flex-direction: column;
}
.four-mode {
  color: red;
  border: 1px solid red;
  border-radius: 6px;
}
</style>
